(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/shared-result/assets/react/components/result-draw-start.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/shared-result/assets/react/components/result-draw-start.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useMemo = _React.useMemo,
  useEffect = _React.useEffect;
const Button = svs.ui.ReactButton;
const _svs$lyckoplatsen$sha = svs.lyckoplatsen.shared_result,
  trackOnShowDirect = _svs$lyckoplatsen$sha.trackOnShowDirect,
  trackOnClickStartDraw = _svs$lyckoplatsen$sha.trackOnClickStartDraw;
const _jotai = jotai,
  useAtom = _jotai.useAtom,
  useSetAtom = _jotai.useSetAtom,
  useAtomValue = _jotai.useAtomValue;
const wagersAtom = svs.lyckoplatsen.shared_mybets_wager.jotai.atoms.wagersAtom;
const _svs$lyckoplatsen$com = svs.lyckoplatsen.components.shared_result.jotai.atoms,
  showFullscreenAtom = _svs$lyckoplatsen$com.showFullscreenAtom,
  correctionStepAtom = _svs$lyckoplatsen$com.correctionStepAtom,
  playCorrectionTlAtom = _svs$lyckoplatsen$com.playCorrectionTlAtom,
  selectedResultAtom = _svs$lyckoplatsen$com.selectedResultAtom,
  correctionTriggerTypeAtom = _svs$lyckoplatsen$com.correctionTriggerTypeAtom,
  distributionArrayAtom = _svs$lyckoplatsen$com.distributionArrayAtom;
const _svs$lyckoplatsen$com2 = svs.lyckoplatsen.components.shared_constants,
  _svs$lyckoplatsen$com3 = _svs$lyckoplatsen$com2.CONSTANTS,
  CORRECTION_TRIGGER_TYPE = _svs$lyckoplatsen$com3.CORRECTION_TRIGGER_TYPE,
  CORRECTION_STEP = _svs$lyckoplatsen$com3.CORRECTION_STEP,
  productMapping = _svs$lyckoplatsen$com2.productMapping;
const formatTime = svs.utils.date.FormatTime;
const getCorrectionStartAndTopWinHandler = svs.lyckoplatsen.components.shared_map.getCorrectionStartAndTopWinHandler;
const ResultStartSvg = svs.lyckoplatsen.components.shared_result.react.components.ResultStartSvg;
const isSelfService = svs.core.config.data.svsconfig.isSelfService;
const topWinHandler = getCorrectionStartAndTopWinHandler();
const wagerHelper = svs.lyckoplatsen.shared_mybets_wager.utils.wagerHelper;
const _svs$lyckoplatsen$com4 = svs.lyckoplatsen.components.shared_result.react.components,
  ResultDrawTopWin = _svs$lyckoplatsen$com4.ResultDrawTopWin,
  MapMini = _svs$lyckoplatsen$com4.MapMini;
const ResultDrawStart = _ref => {
  let setResultDrawStartVisible = _ref.setResultDrawStartVisible;
  const setCorrectionTriggerType = useSetAtom(correctionTriggerTypeAtom);
  const setCorrectionStep = useSetAtom(correctionStepAtom);
  const correctionStep = useAtomValue(correctionStepAtom);
  const _useAtom = useAtom(playCorrectionTlAtom),
    _useAtom2 = _slicedToArray(_useAtom, 2),
    play = _useAtom2[0],
    setPlay = _useAtom2[1];
  const showFullscreen = useAtomValue(showFullscreenAtom);
  const wagers = useAtomValue(wagersAtom);
  const result = useAtomValue(selectedResultAtom);
  const rawDistributionArray = useAtomValue(distributionArrayAtom);
  const distributionArray = useMemo(() => rawDistributionArray || [], [rawDistributionArray]);
  const showResultClick = () => {
    if (wagers !== null && wagers !== void 0 && wagers.length) {
      var _wagers$0$properties;
      const wins = wagerHelper.getWins(wagers, result);
      const isPrimary = productMapping.isLyckoplatsenPrimary(result.productId);
      const channel = (_wagers$0$properties = wagers[0].properties) === null || _wagers$0$properties === void 0 ? void 0 : _wagers$0$properties.channel;
      const win = wins.reduce((acc, win) => acc + parseFloat(win.amount), 0);
      trackOnShowDirect({
        channel,
        isPrimary,
        win
      });
    }
    setCorrectionStep(CORRECTION_STEP.RESULT);
  };
  const onClickStartDraw = () => {
    if (!showFullscreen) {
      trackOnClickStartDraw();
    }
    if (productMapping.isLyckoplatsenPrimary(result.productId)) {
      topWinHandler.tlTopWinPlay();
    }
    setPlay(true);
    setResultDrawStartVisible === null || setResultDrawStartVisible === void 0 || setResultDrawStartVisible(false);
  };
  if (showFullscreen) {
    setTimeout(() => {
      const startDrawButton = document.querySelector('#start-draw-button'); 
      startDrawButton === null || startDrawButton === void 0 || startDrawButton.click();
    }, 5000);
  }
  useEffect(() => {
    const eventHandlers = {
      automatedStepUpdate: index => {
        setCorrectionTriggerType(CORRECTION_TRIGGER_TYPE.AUTOMATED);
        setCorrectionStep(index);
      }
    };
    topWinHandler.initiateDrawStartAndTopWinExperience(result, distributionArray, isSelfService, eventHandlers);
    return () => {
      topWinHandler.tlTopWinKillAndRemove();
    };
  }, [result, distributionArray, setCorrectionTriggerType, setCorrectionStep]);

  useEffect(() => {
    if (productMapping.isLyckoplatsenSecondary(result.productId)) {
      if (play) {
        topWinHandler.tlTopWinPlay();
      } else {
        topWinHandler.tlTopWinPause();
      }
    }
  }, [play, correctionStep, result.productId]);
  return React.createElement("div", {
    className: "lp-draw-start gsap-draw-start"
  }, React.createElement("div", {
    className: "start-body"
  }, React.createElement("div", {
    className: "lp-header"
  }, formatTime('EEEE d/M yyyy', result.regCloseTime)), React.createElement("div", {
    className: "start-content gsap-draw-start-content"
  }, React.createElement(ResultDrawTopWin, {
    className: "gsap-top-win-start"
  }), wagers && React.createElement("div", {
    className: "start-map"
  }, React.createElement(MapMini, null)), !wagers && productMapping.isLyckoplatsenSecondary(result.productId) && React.createElement("div", {
    className: "start-map"
  }, React.createElement(ResultStartSvg, null)), wagers && React.createElement("div", {
    className: "start-text-wagers"
  }, "Du deltar med ", wagers.length, " ", wagers.length === 1 ? 'plats' : 'platser'), React.createElement("div", {
    className: "start-buttons gsap-start-buttons"
  }, React.createElement(Button, {
    id: "start-draw-button",
    className: "lp-green",
    block: true,
    size: 300,
    onClick: () => onClickStartDraw()
  }, "Starta dragning"), React.createElement(Button, {
    block: true,
    transparent: true,
    inverted: true,
    size: 300,
    onClick: () => showResultClick()
  }, "Visa resultat direkt"))), React.createElement("div", {
    className: "start-content-primary-text gsap-draw-start-primary-text gsap-hide"
  }, "Nu avg\xF6rs hur stor toppvinsten blir!")));
};
setGlobal('svs.lyckoplatsen.components.shared_result.react.components', {
  ResultDrawStart
});

 })(window);